import { FLAG_NAMES } from "../flag-constants";
import { SettingsConfig } from "../settings-type";

const defaultSettings: SettingsConfig = {
  [FLAG_NAMES.DATADOG_RUM_ENABLED]: false,
  [FLAG_NAMES.FLAG_TO_TEST_WITH]: false,
};

export default defaultSettings;
